// Global fetch interceptor for handling expired tokens
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  
  // If unauthorized (401), dispatch session expired event
  if (response.status === 401) {
    // Only trigger for API calls (not login/register)
    const url = args[0];
    const isAuthEndpoint = typeof url === 'string' && 
      (url.includes('/api/login') || url.includes('/api/register'));
    
    if (!isAuthEndpoint) {
      window.dispatchEvent(new Event('session-expired'));
    }
  }
  
  return response;
};

export {};
